// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-a7bc778c]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.ed-aside__container[data-v-a7bc778c]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
